import * as React from 'react';
import { cn } from '../utils';

export interface TableWrapperProps
  extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  isSidebarOpen?: boolean;
}

export const TableWrapper = React.forwardRef<HTMLDivElement, TableWrapperProps>(
  ({ className, children, isSidebarOpen = false, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'flex w-full max-w-[calc(100vw-3rem)] transition-all duration-700',
        isSidebarOpen && 'lg:max-w-[calc(100vw-304px)]',
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
);

TableWrapper.displayName = 'TableWrapper';
